import {useNavigate, useParams} from "react-router-dom";
import Header from "../Components/Header/Header";
import Footer from "../Components/Footer/Footer";
import './Careers.css';
import { IMAGE_URL} from "../path";
import {useEffect, useState} from "react";
import {isMobile} from "react-device-detect";
import {getVacancy} from "../actions/ApiCalls";

function Career() {
    const [career, setCareer] = useState<any>({});
    const imgUrl = IMAGE_URL;
    const { slug } = useParams<{slug?: string }>();

    const linkStyle: React.CSSProperties = {
        color: 'black',
        fontSize: '10px',
        fontFamily: "'Vinimark-Diatype', sans-serif",
        fontWeight: 600,
        textTransform: 'uppercase',
        textDecoration: 'underline',
        cursor: 'pointer',
        marginLeft: '10px'
    };

    useEffect(() => {
        document.title = "Vinimark | " + career?.title;
        window.scrollTo(0, 0);
        getCareer();
    }, []);

    function getCareer() {
        if (slug) {
            getVacancy(slug)
                .then(response => {
                    console.log(response.data);
                    setCareer(response.data);
                })
                .catch(error => {
                    console.error("Failed to fetch career:", error);
                });
        }
    }

    const navigate = useNavigate();

    return (
        <div>
            <Header />
            <div style={{display: 'flex', flexDirection: window.innerWidth > 575 ? 'row' : 'column', marginTop: '140px', textAlign: 'left'}}>
                <div style={{flex: 1}}></div>
                <div style={{flex: 1, marginLeft: '36px'}}><p><a style={linkStyle} onClick={() => navigate('/vacancies')}>BACK to Careers</a></p></div>
            </div>
            <div style={{marginTop: '72px', textAlign: 'left', paddingRight: window.innerWidth > 575 ? '0px' : 0, display: 'flex', flexDirection: window.innerWidth > 835 ? 'row' : 'column', gap: '20px'}}>
               <div style={{flex: 1}}>
                   <img src={imgUrl + career.image_path} alt={career.name} style={{width: '100%'}} />
               </div>
                <div style={{flex: 1, marginLeft: '20px'}}>
<div style={{width: isMobile ? '90%' : '60%'}}>
    <p style={{fontWeight: 600, textTransform: 'uppercase', marginBottom: '10px'}}>{career.title}</p>
    <p style={{fontWeight: 600, fontSize: '10px', marginBottom: '10px'}}>{career.year_posted}</p>
    <div
    dangerouslySetInnerHTML={{
        __html: (career.content || '').replace(
            /<p>/g,
            '<p class="career-p">'
        )
    }}
/>
</div>

                </div>
            </div>
            <Footer />
        </div>
    )
}

export default Career;
